(() => {
  const productMediaSelector = [
    'body.product .product-detail__media img',
    'body.product .product__media img',
    'body.product .media-gallery img',
    'body.product .product-media-container img'
  ].join(',');

  function protectProductImages(root = document) {
    root.querySelectorAll(productMediaSelector).forEach((image) => {
      image.draggable = false;
      image.setAttribute('data-icp-image-protected', '');
    });
  }

  document.addEventListener('contextmenu', (event) => {
    if (event.target.closest(productMediaSelector)) {
      event.preventDefault();
    }
  });

  document.addEventListener('dragstart', (event) => {
    if (event.target.closest(productMediaSelector)) {
      event.preventDefault();
    }
  });

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-icp-store-open]');
    const closeButton = event.target.closest('[data-icp-store-close]');

    if (openButton) {
      const modal = document.getElementById(openButton.dataset.icpStoreOpen);
      if (!modal) return;
      modal.hidden = false;
      document.documentElement.classList.add('icp-store-modal-open');
      modal.querySelector('[role="dialog"]')?.focus();
    }

    if (closeButton) {
      const modal = document.getElementById(closeButton.dataset.icpStoreClose);
      if (!modal) return;
      modal.hidden = true;
      document.documentElement.classList.remove('icp-store-modal-open');
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const modal = document.querySelector('.icp-store-modal:not([hidden])');
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.classList.remove('icp-store-modal-open');
  });

  document.addEventListener('DOMContentLoaded', () => protectProductImages());
  document.addEventListener('shopify:section:load', (event) => protectProductImages(event.target));
})();
